import PropTypes from 'prop-types'

import {atomIconColors, atomIconSizes} from '@s-ui/react-atom-icon'
import AtomInput, {inputShapes, inputTypes} from '@s-ui/react-atom-input'
import {useSuiContext} from '@s-ui/react-context'
import VisuallyHidden from '@s-ui/react-primitive-visually-hidden'
import SpinnerBasic, {spinnerBasicOverlayTypes, spinnerBasicSizes} from '@adv-mt/mt-spinner-basic'
import IconSearch from '@adv-mt/mt-svg-icons/lib/Search.js'

import {BASE_ELEMENTS_TYPES, DEFAULT_SEARCH, INPUT_MAX_LENGTH, NO_OP, SEARCH_AI_INPUT_ID} from './config.js'

const SearchAiInput = ({isLoading, onBlur, onChange, onFocus, onSearch, search}) => {
  const {i18n} = useSuiContext()

  const handleChange = e => {
    onChange(e.target.value)
  }

  const handleCleanSearch = () => {
    onChange(DEFAULT_SEARCH)
  }

  const handleSearch = e => {
    e.target.blur()
    onSearch()
  }

  const LoadingIcon = <SpinnerBasic overlayType={spinnerBasicOverlayTypes.TRANSPARENT} size={spinnerBasicSizes.SMALL} />

  return (
    <div className="mt-SearchAiInput">
      <VisuallyHidden as={BASE_ELEMENTS_TYPES.LABEL} htmlFor={SEARCH_AI_INPUT_ID}>
        {i18n.t('SEARCH_AI.INPUT_PLACEHOLDER.DEFAULT')}
      </VisuallyHidden>
      <AtomInput
        autocomplete="off"
        id={SEARCH_AI_INPUT_ID}
        leftIcon={
          <IconSearch aria-hidden color={atomIconColors.gray} role="presentation" size={atomIconSizes.medium} />
        }
        maxLength={INPUT_MAX_LENGTH}
        onBlur={onBlur}
        onChange={handleChange}
        onClickRightIcon={handleCleanSearch}
        onEnter={search ? handleSearch : NO_OP}
        onFocus={onFocus}
        placeholder={i18n.t(`SEARCH_AI.INPUT_PLACEHOLDER.DEFAULT`)}
        rightIcon={isLoading && LoadingIcon}
        shape={inputShapes.CIRCLE}
        type={inputTypes.SEARCH}
        value={search}
      />
    </div>
  )
}

SearchAiInput.displayName = 'SearchAiInput'
SearchAiInput.propTypes = {
  isLoading: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onSearch: PropTypes.func,
  search: PropTypes.string
}

export default SearchAiInput
